import Chip from '@mui/material/Chip'

import { isBefore } from '../../core/util/date-util'
import type { JobSchedule } from '../types/JobSchedule'

const label2color = {
  running: 'warning',
  completed: 'success',
  failed: 'error',
  scheduled: 'primary',
  queued: 'secondary',
}

const status2label = ({ status, nextRunAt }: JobSchedule) => {
  if (status === 'scheduled' && nextRunAt && isBefore(nextRunAt, new Date())) {
    return 'queued'
  }
  return status
}

interface Props {
  jobSchedule: JobSchedule
}

export const JobScheduleStatus = ({ jobSchedule }: Props) => {
  const label = status2label(jobSchedule)
  const color = label2color[label]

  return (
    <Chip
      label={label}
      color={color}
      variant="outlined"
      sx={{
        width: '120px',
        backgroundColor: 'white',
      }}
    />
  )
}
